<template>
  <div class="step--decorators">
    <div class="decorator">
      <div class="circle"></div>
      <div class="line"></div>
    </div>
    <div class="decorator">
      <div class="circle"></div>
      <div class="line"></div>
    </div>
    <div class="decorator">
      <div class="circle"></div>
    </div>
  </div>
</template>

<script>
// Components

export default {
  name: "StepDecorator",
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";
@import "@/assets/styles/components/shared/step-decorator.scss";
</style>
